
import {
  qyTicket
} from "@/api/home";
import authSource from '../components/authSource.vue'
let that=this
export function initWxConfig(vm) {
  // var url ="http://"+ window.location.hostname //经测试发现，hash模式下动态获取url不正确，写项目的入口地址即可，#及后面的部分去掉
  var url = window.location.origin
  return false
  let schoolId = localStorage.getItem("xpschoolId");
  if (schoolId) {
    return false
  }
  if(authSource.authSource=='system'){
    return false
  }
  qyTicket({
      url: url,
    })
    .then((response) => {
      console.log(response)
      if (response.status == 200) {
        var timestamp = response.data.rtdata.timestamp; //时间戳
        var nonceStr = response.data.rtdata.noncestr; //随机字符串
        var signature = response.data.rtdata.signature; //签名
        var appId = response.data.rtdata.appid; //企业id
        var agentid = response.data.rtdata.agentid; //企业id

        wx.agentConfig({
          beta: true, // 必须这么写，否则wx.invoke调用形式的jsapi会有问题
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          corpid: appId, // 必填，企业微信的corpID
          agentid:agentid,
          timestamp:timestamp, // 必填，生成签名的时间戳
          nonceStr: nonceStr, // 必填，生成签名的随机串
          signature: signature, // 必填，签名，见附录1
          jsApiList: ['selectEnterpriseContact'], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
           success: function(res) {
                // 回调
                console.log(res)
            },
            fail: function(res) {
              console.log(res)
                if(res.errMsg.indexOf('function not exist') > -1){
                    alert('版本过低请升级')
                }
            }
        });
        wx.ready(function () {
          WWOpenData.bind(document.querySelector("ww-open-data"));
        });
        wx.error(function (res) {});
      } else {
      }
    })
    .catch((error) => {
      //   Toast(JSON.stringify(error))
    });
}


// WEBPACK FOOTER //
// ./src/api/initWxConfig.js